module.exports = __webpack_public_path__ + "img/KurdoShaban.106fe5a8.jpg";